import { Link } from '@tanstack/react-router'
import clsx from 'clsx'
import { type MouseEvent, useContext } from 'react'
import type { OrderHead } from '~/domains/orders/types'
import { formatOrderTitle } from '~/domains/orders/utils'
import { ApplicantModalContext } from '~/utils/contextes'
import { buildV3Url } from '~/utils/legacy'
import { orderTag, orderTagCompany, orderTagTitle } from './OrderTag.css'

export const OrderTag = ({
  order,
  className
}: {
  order: OrderHead
  className?: string
}) => {
  const { setApplicantCurrentId } = useContext(ApplicantModalContext)
  const orderPath = `/orders/${order.id}`

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation()
    setApplicantCurrentId(null)
  }

  const content = (
    <>
      <span className={orderTagCompany}>
        {order.company.name}
        {order.status === 0 ? ' (fermée)' : ''}
      </span>
      {formatOrderTitle(order).length > 0 && (
        <span className={orderTagTitle}>{formatOrderTitle(order)}</span>
      )}
    </>
  )

  if (window.JobConfig) {
    return (
      <a
        href={buildV3Url(orderPath)}
        className={clsx(orderTag, className)}
        onClick={handleClick}
      >
        {content}
      </a>
    )
  }

  return (
    <Link
      to="/orders/$orderId"
      params={{ orderId: String(order.id) }}
      className={clsx(orderTag, className)}
      onClick={handleClick}
    >
      {content}
    </Link>
  )
}
